import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static outlets = ['selectable-table-actions']
  static targets = ['row', 'rowSelector', 'allRowSelector']

  selectAll(event) {
    if (this.hasAllRowSelectorTarget) {
      this.changeAll(this.allRowSelectorTarget.checked)
    }
  }

  changeAll(selected) {
    this.rowSelectorTargets.forEach((_rowSelector, index) => {
      this.rowSelectorTargets[index].checked = selected
    })

    this.selectionChanged()
  }

  selectionChanged() {
    this.updateAllRowSelector()
    this.updateRowSelectedClass()

    const event = new CustomEvent('selectableTableChanged', { bubbles: true })
    this.element.dispatchEvent(event)
  }

  updateAllRowSelector() {
    if (this.hasAllRowSelectorTarget) {
      this.allRowSelectorTarget.checked = !this.hasUnselectedRows()
    }
  }

  // CSS and other JS (i.e. in app/views/users/index.html.erb) use classes as
  // the source of truth on if a row is selected. So we sync that classes to
  // status of the rowSelector checkboxes.
  updateRowSelectedClass() {
    this.rowSelectorTargets.forEach((rowSelector, index) => {
      this.rowTargets[index].classList.toggle('selected', rowSelector.checked)
    })
  }

  selectedIds() {
    const indexes = this.selectedIndexes()

    return indexes.map(index => this.rowTargets[index].getAttribute('data-id'))
  }

  selectedIndexes() {
    const selectedIndexes = []

    this.rowSelectorTargets.forEach((rowSelector, index) => {
      if (rowSelector.checked) { selectedIndexes.push(index) }
    })

    return selectedIndexes
  }

  hasSelectedRows() {
    return this.rowSelectorTargets.some(selector => selector.checked)
  }

  hasUnselectedRows() {
    return this.rowSelectorTargets.some(selector => !selector.checked)
  }
}
